/**
 * lucide-react v0.115.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const LayoutGrid = createLucideIcon("LayoutGrid", [
  ["rect", { x: "3", y: "3", width: "7", height: "7", key: "1q9d4d" }],
  ["rect", { x: "14", y: "3", width: "7", height: "7", key: "1kofyi" }],
  ["rect", { x: "14", y: "14", width: "7", height: "7", key: "18jxcw" }],
  ["rect", { x: "3", y: "14", width: "7", height: "7", key: "1omegr" }]
]);

export { LayoutGrid as default };
//# sourceMappingURL=layout-grid.js.map
